import {hel_SetServerTime} from '../logics/lib';

import type {RefreshChannelSessionData} from '../types/network';
export class CChannelSessionApi {
  m_HeartbeatSendSpan: number = 30000;
  m_HeartbeatObserveInterval: number | null;

  // コンストラクタ
  constructor() {
    this.m_HeartbeatObserveInterval = null;
  }

  /** ChannelSessionAPIのハートビートを起動 */
  startHeartbeat() {
    this.m_HeartbeatObserveInterval = window.setInterval(async () => {
      const resHeartbeat =
        await globalThis.heliport.v3.api.channelSessionApi.refreshChannelSession();
      if (resHeartbeat.status !== 'ok') {
        throw new Error(
          `Failed to refresh channel session:\n${JSON.stringify(resHeartbeat, null, 2)}`
        );
      }
      hel_SetServerTime((resHeartbeat.data as RefreshChannelSessionData).response_timestamp);
    }, this.m_HeartbeatSendSpan);
  }

  /** ChannelSessionAPIのハートビートの停止 */
  stopHeartbeat() {
    if (this.m_HeartbeatObserveInterval) {
      window.clearInterval(this.m_HeartbeatObserveInterval);
    }
  }
}
